// extracted by mini-css-extract-plugin
export default {"tableHead":"BaselineList_tableHead__9IyNk","tableBodyRow":"BaselineList_tableBodyRow__Tiztx"};